import React, { useState } from "react";
import TimePicker from "react-time-picker";
import 'react-time-picker/dist/TimePicker.css';
import { InputProps } from "./Input";

interface Props {
    inputProps: InputProps;
    disabled: boolean | undefined;
}

const TimePickerField: React.FC<Props> = ({ inputProps: originalInputProps, disabled }) => {
    const inputProps = Object.assign({}, originalInputProps);

    const timeValue = inputProps.value ? inputProps.value.toString() : "";
    const [time, setTime] = useState<string>(timeValue);

    return (
        <TimePicker
            name={inputProps.name}
            locale={"fr"}
            disabled={disabled}
            format={"HH:mm"}
            value={time}
            disableClock={true}
            onChange={(newTime: string | null) => {
                const formatted = newTime ?? "";
                setTime(formatted);
                // @ts-ignore
                inputProps.onChange(formatted);
            }}
            className={inputProps.className}
        />
    );
};

export default TimePickerField;
